/// <reference path="../_all.ts" />

module part {

  PartBoxDirective.$inject = [
    'pageMetaService',
    'partService', 
    'anchorNavService',
    '$mdDialog',];

  export function PartBoxDirective(
      pageMetaService: navigation.IPageMetaService,
      partService: IPartService,
      anchorNavService: navigation.IAnchorNavService,
      $mdDialog: ng.material.IDialogService): ng.IDirective {


    return {
      restrict: 'E',
      scope: {
        part: '=',
        pictures: '=',
        partToProduct: '=',
        showAsLine: '=',
        availabilityData: '=',
      },
      templateUrl: 'part/PartBoxDirective',
      link: function (scope: IPartBoxDirectiveScope, element: ng.IAugmentedJQuery, attr: ng.IAttributes) {
        scope.meta = pageMetaService.getPageMeta;
        scope.requestOnGoing = false;

        scope.$watch('qty', (newValue: number, oldValue: number, scope: IPartBoxDirectiveScope) : any => {
          scope.qty = Math.max(scope.qty, 1);
        });

        scope.openDetailModal = (ev: MouseEvent, partid: string) => {
          partService.openDialog(partid, scope, scope.partToProduct, ev);
        }


      }
    }
  }

}